<script lang="ts" setup>
const props = defineProps<{
  items: []
}>()
</script>

<template>
  <div class="flex">
    <NuxtLink v-for="(item, idx) in props.items" :key="idx" :to="item.route" class="border-b-surface-500 text-surface-500 hover:border-b-surface-700 hover:text-surface-700 text-med-normal border-b px-4 py-2 transition-all" exact-active-class="border-b-surface-900! text-surface-900!">{{ item.label }}</NuxtLink>
  </div>
</template>
